import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { ToastService } from '@app/services/toast.service';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  USER_TOKEN_KEY: string = 'tems-user-token';
  USER_TOKEN_USER: string = 'tems-user-user';

  // PermissionsService depends on AuthService (via HelpersService), so
  // AuthService can't depend back on PermissionsService — even lazily via
  // Injector.get() — without Angular flagging a circular DI (NG0200) the
  // first time PermissionsService is constructed. Emitting an event here
  // for PermissionsService to subscribe to keeps the dependency one-way.
  private authEvents = new Subject<void>();
  readonly authEvents$ = this.authEvents.asObservable();

  constructor(
    private httpService: HttpService,
    private router: Router,
    private toastr: ToastService
  ) { }
  userLogin(payload: any) {
    return this.httpService.post('api/Authentication', payload);
  }
  ssoLogin(payload: any) {
    return this.httpService.post('api/Authentication/SSOLogin', payload, {
      headers: new HttpHeaders({ 'X-Skip-Toast': 'true' }),
    });
  }
  forgotPassword(payload: any) {
    return this.httpService.post('api/User/forgetpasswordotp', payload);
  }
  resetPassword(payload: any) {
    return this.httpService.post('api/User/forgetpassword', payload);
  }
  deleteUserByEmail(email: string) {
    return this.httpService.delete('api/User/DeleteUserByEmail/' + email);
  }
  userSuccessLogin(data: any, rememberme: boolean = false, encodedUrl: string) {
    this.authEvents.next();
    let user = {
      ssoRedirectUrl: data?.ssoRedirectUrl,
      accountTeam: data?.accountTeam,
      gradeName: data?.grades?.gradeName,
      employeeCode: data?.employeeCode,
      userRoles: data?.userRoles,
      userId: data?.id,
      companyAccountId: data?.companyAccountId,
      email: data?.email,
      approvalLevel: data?.approvalLevel,
      isDirector: data?.isDirector,
      name: data?.firstName + ' ' + data?.lastName,
    };
    if (rememberme == true) {
      localStorage.setItem(
        this.USER_TOKEN_KEY,
        this.encrypt(data?.bearerToken)
      );
      localStorage.setItem(
        this.USER_TOKEN_USER,
        this.encrypt(JSON.stringify(user))
      );
    } else {
      sessionStorage.setItem(
        this.USER_TOKEN_KEY,
        this.encrypt(data?.bearerToken)
      );
      sessionStorage.setItem(
        this.USER_TOKEN_USER,
        this.encrypt(JSON.stringify(user))
      );
    }
    this.router.navigate([encodedUrl ?? '/dashboard']);
  }
  getUserToken() {
    let token = localStorage.getItem(this.USER_TOKEN_KEY);
    if (!token) {
      token = sessionStorage.getItem(this.USER_TOKEN_KEY);
    }
    return token ? this.decrypt(token) : null;
  }
  getUserData() {
    let data = localStorage.getItem(this.USER_TOKEN_USER);
    if (!data) {
      data = sessionStorage.getItem(this.USER_TOKEN_USER);
    }
    return data ? this.decrypt(data) : null;
  }
  userLogout() {
    this.httpService.post('api/Authentication/logout', {}).subscribe({
      next: (res: any) => {
        if (res?.status === true) {
          // ✅ Successful server logout
          this.clearAuthStorage();

          if (res?.redirectURL) {
            // Redirect to server-provided URL
            window.location.href = res.redirectURL;
          } else {
            // Fallback to local login route
            this.router.navigateByUrl('/auth/login');
          }

          this.toastr.success(res?.message || 'Logged out successfully');
        } else {
          // ⚠️ Server responded but status not true
          this.clearAuthStorage();
          this.router.navigateByUrl('/auth/login');
          this.toastr.warning('Logout response invalid, cleared local session');
        }
      },
      error: (err) => {
        console.error('Logout failed:', err);
        // ❌ API call failed, still clear client storage
        this.clearAuthStorage();
        this.router.navigateByUrl('/auth/login');
        this.toastr.warning('Logout failed on server, cleared local session');
      }
    });
  }


  private clearAuthStorage() {
    localStorage.removeItem(this.USER_TOKEN_KEY);
    localStorage.removeItem(this.USER_TOKEN_USER);
    sessionStorage.removeItem(this.USER_TOKEN_KEY);
    sessionStorage.removeItem(this.USER_TOKEN_USER);
    this.authEvents.next();
  }



  userLoggedIn() {
    return !!this.getUserToken();
  }
  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(
      txt.toString(),
      environment.SECRET_KEY
    ).toString();
  }

  private decrypt(txtToDecrypt: string) {
    if (!txtToDecrypt) {
      return null;
    }

    try {
      const decryptedBytes = CryptoJS.AES.decrypt(
        txtToDecrypt,
        environment.SECRET_KEY
      );
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedText ? decryptedText : null;
    } catch (error) {
      console.error('Decryption failed:', error);
      this.userLogout();
      return null;
    }
  }
  HRMS_REDIRECTION(res: any) {
    localStorage.removeItem(this.USER_TOKEN_KEY);
    localStorage.removeItem(this.USER_TOKEN_USER);
    sessionStorage.removeItem(this.USER_TOKEN_KEY);
    sessionStorage.removeItem(this.USER_TOKEN_USER);
    this.userSuccessLogin(res, true, '');
  }
  HRMSLoginVerify(params: URLSearchParams) {
    return this.httpService.get(
      'api/Authentication/HRMSLoginVerify?' + params.toString()
    );
  }
}
